import React, { useContext, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import { VerticalContext } from 'store/verticals/Context'
import Details from 'containers/VerticalPage/freelancers/Details/Details'
import Content from 'containers/VerticalPage/freelancers/Content/Content'
import { useSelector } from 'react-redux'
import { selectCurrentZone } from 'store/global'
import type { CurrentZone } from 'utils/types'
import VerticalDetailsContextProvider from 'store/verticalsDetails/Context'
import VerticalPageWrapper from 'containers/VerticalPage/common/VerticalPageWrapper/VerticalPageWrapper'
import { changeCurrentZoneIndexesFunc } from 'containers/VerticalPage/common/utils'

const VerticalPage = (props: { changeCurrentZoneIndexes: changeCurrentZoneIndexesFunc }) => {
  const { getGraphData } = useContext(VerticalContext)
  const [isLoadingGraph, setIsLoadingGraph] = useState(false)
  const { entityId } = useParams<{ entityId: string }>()
  const currentZone: CurrentZone = useSelector(selectCurrentZone)

  useEffect(() => {
    props.changeCurrentZoneIndexes({
      baseIndices: currentZone?.gigIndices,
      activityIndices: currentZone?.gigActivityIndices,
    })
  }, [currentZone])

  useEffect(() => {
    if (!entityId || !currentZone) return
    const fetchGraphData = async () => {
      setIsLoadingGraph(true)
      await getGraphData(entityId, currentZone.gigGraphIndices)
      setIsLoadingGraph(false)
    }
    fetchGraphData()
  }, [entityId, currentZone, getGraphData])

  return (
    <VerticalPageWrapper
      gridContainerSx={{
        gridTemplateColumns: '100%',
      }}
    >
      <Content />
      <VerticalDetailsContextProvider>
        <Details />
      </VerticalDetailsContextProvider>
    </VerticalPageWrapper>
  )
}

export default VerticalPage
